// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function() {

 var MAX_CHARACTERS_ALLOWED = 1000;
  Certifications.Modals.CertificationModal = createReactClass({
    PropTypes: {
      workTitle: PropTypes.string,
      source: PropTypes.string.isRequired,
      sourceDetails: PropTypes.object,
      workId: PropTypes.number,
      url: PropTypes.string,
      modalId: PropTypes.number,
      onCertify: PropTypes.func
    },

    getInitialState: function() {
      return {
        userHasReadWork: false,
        workIsWorthwhile: false,
        workIsAcademicResearch: false,
        commentBody: null,
        waiting: false
      };
    },
    componentDidMount: function() {
      $("[data-toggle='tooltip']").tooltip();
    },
    componentWillMount: function() {
      this.newCertificationStore = Flux.Certifications.NewCertificationStore;
      this.newCertificationStore.initialize(this, this.onCertificationReady, this);
    },
    componentWillUnmount: function() {
      this.newCertificationStore.cleanup(this.onCertificationReady);
    },
    changedCommentBody: function(e) {
      this.setState({
        commentBody: e.target.value
      });
    },
    tickedReadWork: function(checked) {
      this.setState({
        userHasReadWork: checked
      });
    },
    tickedWorkWorthwhile: function(checked) {
      this.setState({
        workIsWorthwhile: checked
      });
    },
    tickedWorkAcademicResearch: function(checked) {
      this.setState({
        workIsAcademicResearch: checked
      });
    },
    submitCertify: function() {
      Flux.Dispatcher.dispatch({
        actionType: 'certification-create',
        source: this.props.source,
        sourceDetails: this.props.sourceDetails,
        workId: this.props.workId,
        url: this.props.url,
        commentBody: this.state.commentBody,
        details: {
          user_has_read_work: this.state.userHasReadWork,
          work_is_worthwhile: this.state.workIsWorthwhile,
          work_is_academic_research: this.state.workIsAcademicResearch
        }
      });
      this.setState({
        waiting: true
      });
    },
    onCertificationReady: function(event) {
      if (event.success) {
        this.hideWithSuccessMessage();
      } else {
        this.hideWithErrorMessage(event.errors);
      }
    },
    hideWithSuccessMessage: function() {
      $("#" + this.props.modalId + " .modal-content").html("<div class=\"DesignSystem\"><div class=\"u-m8x alert alert-success\">You've successfully recommended this paper.</div></div>");
      setTimeout(function() {
        $('#' + this.props.modalId).modal('hide');
        if (this.props.onCertify) {
          this.props.onCertify();
        }
      }.bind(this), 2000);
    },
    hideWithErrorMessage: function(errors) {
      var text = errors.length > 0 ? "Something went wrong: " + ($h.encodeHTML(errors[0])) : "Something went wrong! Recommendation failed.";
      $("#" + this.props.modalId + " .modal-content").html("<div class=\"DesignSystem\"><div class=\"u-m8x alert alert-danger\"> " + text + " </div></div>");
      setTimeout(function() {
        $('#' + this.props.modalId).modal('hide');
      }.bind(this), 5000);
    },
    render: function() {
      var header = this.renderHeader();
      var body = this.renderBody();
      return (
        <div className="DesignSystem">
          <Components.Modals.HeaderBodyClose header={header} body={body}/>
        </div>
      );
    },
    renderHeader: function() {
      var labelStyles = 'u-fs20 u-tcGrayDarkest u-mv4x u-taCenter u-textCapitalize';
      return (
        <div className={labelStyles}> {'recommend'} </div>
      );
    },
    quotedWorkOrGenericTitle: function() {
      if (this.props.workTitle) {
        return "\u201c" + this.props.workTitle + ",\u201d";
      } else {
        return "this paper,";
      }
    },
    renderBody: function() {
      return (
        <div className="u-m6x">
          {this.checkboxesHeader()}
          <div>
            {this.hasReadWorkCheckbox()}
          </div>
          <div>
            {this.workIsAcademicResearchCheckbox()}
          </div>
          <div className="u-mb4x">
            {this.workIsWorthwhileCheckbox()}
          </div>
          {this.commentAndSubmitArea()}
        </div>
      );
    },
    checkboxesHeader: function() {
      return (
        <div>
          <p className="u-fw700 u-mb5x">
            To recommend {this.quotedWorkOrGenericTitle()} please verify that:
          </p>
        </div>
      );
    },
    hasReadWorkCheckbox: function() {
      return (
        <Components.Compound.CheckboxLabel
          ref="hasReadWork"
          labelClasses="u-tcGrayDarker u-fw700"
          onChange={this.tickedReadWork}
          disabled={this.state.waiting}
          label="I have read this paper."
        />
      );
    },
    workIsWorthwhileCheckbox: function() {
      return (
        <Components.Compound.CheckboxLabel
          ref="isWorthwhileWork"
          labelClasses="u-tcGrayDarker
          u-fw700"
          onChange={this.tickedWorkWorthwhile}
          disabled={this.state.waiting}
          label="This paper is a worthwhile contribution to the literature."
        />
      );
    },
    workIsAcademicResearchCheckbox: function() {
      return (
        <Components.Compound.CheckboxLabel
          ref="isAcademicResearchWork"
          labelClasses="u-tcGrayDarker
          u-fw700"
          onChange={this.tickedWorkAcademicResearch}
          disabled={this.state.waiting}
          label="This is a work (paper, book, etc.) of academic research."
        />
      );
    },
    commentAndSubmitArea: function() {
      var textAreaStyle = "TextArea TextArea--disableResize TextArea--dark u-mb3x";
      var textAreaPlaceholder = "Explain what you found worthwhile about this paper.";
      return (
        <div>
          <textarea
            ref="commentBody"
            className={textAreaStyle}
            placeholder={textAreaPlaceholder}
            onChange={this.changedCommentBody}
            rows="4"
            disabled={this.state.waiting}
            maxLength={MAX_CHARACTERS_ALLOWED}
          />
          {this.charactersRemainingLabel()}
          {this.submitButton()}
        </div>
      );
    },

    charactersRemainingLabel: function(){
      return(
        <div className="u-taRight u-fw400 u-fs13 u-lineHeight1 u-pb8x u-tcGrayDarker">
          {(MAX_CHARACTERS_ALLOWED - (this.state.commentBody ? this.state.commentBody.length : 0)) + " characters remaining"}
        </div>
      );
    },

    submitButton: function() {
      var certifyButtonDisabled = !(this.state.userHasReadWork && this.state.workIsWorthwhile && this.state.workIsAcademicResearch);
      return (
        <button
          className={this.certifyButtonClasses(certifyButtonDisabled)}
          disabled={certifyButtonDisabled}
          onClick={this.submitCertify}
        >
          {this.submitLabel()}
        </button>
    );
    },
    submitLabel: function() {
      if (this.state.waiting) {
        return (
          <div className="u-mt1x">
            <div className="fa fa-spinner fa-spin fa-2x"/>
          </div>
        );
      } else {
        return 'recommend';
      }
    },
    certifyButtonClasses: function(certifyButtonDisabled) {
      return classNames('Button Button--xl Button--block text-uppercase',
        {'Button--disabled': certifyButtonDisabled,
          'Button--green': !certifyButtonDisabled}
        );
      }
  });
})();
